import React from 'react';
import { VideoHLS } from '../../components/VideoHLS';
export function HomeVideoPlayer() {
  return <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-black" data-id="element-1833">
      <VideoHLS src="https://www.stormtaekwondo.com/custom/uploaded/videos/.converted-Storm--Taekwondo-mp4/master.m3u8" title="See Storm Taekwondo Classes & Programs in Action" className="absolute inset-0 w-full h-full object-cover" data-id="element-1834" />
    </div>;
}